<div [hidden]="!Data" #trigger class="tooltip-trigger" (mouseenter)="ShowTooltip()" (mouseleave)="HideTooltip()"
    (touchstart)="ShowTooltip()" (touchend)="HideTooltip()" (click)="$event.stopPropagation()">
    <ng-content></ng-content>
</div>

<!-- Tooltip overlay -->
<div [hidden]="!IsVisible" #tooltip class="tooltip-content" [class]="Position" [ngStyle]="ContentStyle">
    <!-- <ul > -->
    <ion-text class="tooltip-list">{{ Data }}</ion-text>
    <!-- </ul> -->
    <div class="tooltip-arrow" [ngStyle]="ArrowStyle"></div>
</div>